/* eslint-disable max-len */
import PropTypes from 'prop-types'
import { idPropType } from '../common/id-prop-type'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { locationDescriptionPropType } from '../common/location-description-prop-type'
import { positionPropType } from '../common/position-prop-type'
import { fuelTypePropType } from './fuel-type-prop-type'

/**
 * @typedef {Object} FuelLevelEvent
 * @property {number} [distance] - The distance driven during this fuel level event
 * @property {Id} [driverId] - The ID of the driver (if available)
 * @property {number} [duration] - The duration of the fuel level event
 * @property {number} [fuelLevelDifferenceAbsolute] - The absolute fuel level difference (tankSize / 100.0 * fuelLevelDifferenceRelative)
 * @property {number} [fuelLevelDifferenceRelative] - The relative fuel level difference (decreases by consumption/ rises when filled)
 * @property {number} [fuelLevelEnd] - The fuel level at the end of the event
 * @property {ISO8601} [fuelLevelEventTime] - A timestamp of the fuel level event (ISO8601)
 * @property {string} [fuelLevelEventType] - The fuel level event type
 * @property {number} [fuelLevelStart] - The fuel level at the start of the event
 * @property {FuelType} [fuelType] - Fuel type of the vehicle, e.g. ['PETROL', 'DIESEL', 'HYBRID_PETROL',...]
 * @property {LocationDescription} [locationDescription] - The location description of the idling (new TT Reverse Geocoder)
 * @property {Id} [objectId] - The ID of the object
 * @property {Position} [position] - The geo position of the idling (decimal degree)
 * @property {Id} [unitId] - The ID of the unit
 */
export const fuelLevelEventPropType = PropTypes.shape({
    distance: PropTypes.number,
    driverId: idPropType,
    duration: PropTypes.number,
    fuelLevelDifferenceAbsolute: PropTypes.number,
    fuelLevelDifferenceRelative: PropTypes.number,
    fuelLevelEnd: PropTypes.number,
    fuelLevelEventTime: iso8601PropType,
    fuelLevelEventType: PropTypes.oneOf([
        'TRIP',
        'IDLEINTERVAL',
        'FUEL_DECREASED_DRIVING',
        'FUEL_DECREASED_LEAKAGE',
        'FUEL_INCREASED_REFUEL'
    ]),
    fuelLevelStart: PropTypes.number,
    fuelType: fuelTypePropType,
    locationDescription: locationDescriptionPropType,
    objectId: idPropType,
    position: positionPropType,
    unitId: idPropType
})
